import { ProjectMeta } from '@anm/api/modules/uploads';
import getPassedTime from '@anm/helpers/getPassedTime';
import { FC } from 'react';

import { UploadProjectsModalProps } from '..';

import { ListWrapper, ProjectLink, ProjectPreview, Time, Title } from './Wrapper';
import { getProjectUrl } from './helpers';

const DEFAULT_NAME = 'My video project';

const ProjectRow: FC<ProjectMeta> = ({ name, modTime, previewUrl, id }) => (
  <ProjectLink href={getProjectUrl(id)} target="_blank">
    <ProjectPreview src={previewUrl} />
    <div>
      <Title>
        <span>{name || DEFAULT_NAME}</span>
      </Title>
      <Time>{getPassedTime(modTime)}</Time>
    </div>
  </ProjectLink>
);

const ProjectsList: FC<Pick<UploadProjectsModalProps, 'projects'>> = ({ projects }) => (
  <ListWrapper>
    {projects?.map(project => (
      <ProjectRow key={project.id} {...project} />
    ))}
  </ListWrapper>
);

export default ProjectsList;
